<template>
  <v-container class="page-header" fluid>
    <v-row class="mt-2 mb-2">
      <v-col>
        <h3 class="d-inline-block text-primary font-weight-medium text-headline-large">
          {{ title }}
        </h3>
        <div class="d-inline-block line-title ml-3"></div>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import menu from '@/menu/menu';
import menuAdmin from '@/menu/menuAdmin';

export default {
  data() {
    return {
      // title: ""
    };
  },
  mounted() {},
  computed: {
    isAdmin: function () {
      return this.$store.getters['user/isAdmin'];
    },
    title: function () {
      let title = '';
      let menuToUse = this.isAdmin ? menuAdmin : menu;
      menuToUse.forEach(item => {
        if (item.items) {
          let child = item.items.find(i => i.component === this.$route.name);

          if (child) {
            title = child.title;
          }
        } else {
          if (item.name === this.$route.name) {
            title = item.title;
          }
          if (item.href === '/') {
            title = item.title;
          }
        }
      });
      return title;
    },
  },
};
</script>

<style>
.page-header {
  flex: 0 1;
}

.line-title {
  width: 415px;
  border-bottom: 1px solid #959595;
}
</style>
